import { render } from "./TheToolbar.vue?vue&type=template&id=0a266564&scoped=true"
import script from "./TheToolbar.vue?vue&type=script&lang=js"
export * from "./TheToolbar.vue?vue&type=script&lang=js"

import "./TheToolbar.vue?vue&type=style&index=0&id=0a266564&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a266564"]])

export default __exports__